const formatterCache = new Map()

function getFormatter(locale, minimumFractionDigits) {
  const key = `${locale}|${minimumFractionDigits}`
  if (!formatterCache.has(key)) {
    formatterCache.set(
      key,
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits,
      })
    )
  }
  return formatterCache.get(key)
}

/**
 * Validate a (partial) currency input:
 *  • optional leading “$”
 *  • up to group‑formatted ints
 *  • optional . and exactly two decimals
 *  • or “.xx” shorthand
 */
const CURRENCY_RE = /^\$?\d{1,3}(?:,\d{3})*(?:\.\d{0,2})?$|^\.\d{0,2}$/
export function validateCurrency(value) {
  return CURRENCY_RE.test(String(value))
}

/**
 * Format a number as USD.  If `displayFreeForZeroValues` is truthy,
 * zero or less shows “Free” instead of “$0.00”.
 */
export function formatMoney(
  number = 0,
  locale = 'en-US',
  { displayFreeForZeroValues } = {}
) {
  if (number <= 0 && displayFreeForZeroValues) {
    return 'Free'
  }
  const isInteger = Number.isInteger(number)
  const digits    = isInteger ? 0 : 2
  return getFormatter(locale, digits).format(number)
}

/**
 * Cleans up a user’s raw input string into a currency‑style partial:
 *  • strips commas
 *  • enforces single “.” with up to 2 decimals
 *  • truncates integer part formatting on the fly
 */
export function formatInputToCurrency(raw, maxLength = 10) {
  let str = String(raw).replace(/,/g, '').slice(0, maxLength)

  // Force at most one “.”
  const parts = str.split('.')
  if (parts.length > 2) {
    parts.splice(1, parts.length - 2, parts.slice(1).join(''))
  }
  let [intPart, decPart = ''] = parts

  // Truncate decimals to 2
  decPart = decPart.slice(0, 2)

  // If integer part >3 digits, re‑group on the fly
  if (intPart.length > 3) {
    // temporarily parse it as number to get grouping
    const num = parseInt(intPart, 10)
    if (!Number.isNaN(num)) {
      // remove “$” then re‑slice if user was in mid‑typing a “.”
      intPart = getFormatter('en-US', 0)
        .format(num)
        .replace(/\$/g, '')
    }
  }

  return decPart.length > 0
    ? `${intPart}.${decPart}`
    : intPart
}